var _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArchive = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 63,
  viewBox: "0 0 60 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 13.8997H45.9333C48.1241 13.8997 49.9 15.7801 49.9 18.0997V47.4997C49.9 49.8193 48.1241 51.6997 45.9333 51.6997H18.1667C15.9759 51.6997 14.2 49.8193 14.2 47.4997C14.2 36.0183 14.2 21.1811 14.2 9.69971",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 20.6992,
  y1: 24.0591,
  x2: 43.3992,
  y2: 24.0591,
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 20.6992,
  y1: 32.4592,
  x2: 43.3992,
  y2: 32.4592,
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 20.6992,
  y1: 40.8591,
  x2: 32.8992,
  y2: 40.8591,
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})));
export default SvgIconArchive;